import gql from 'graphql-tag'

export const CREATE_PRINT = gql`
  mutation createPrint($accreditationUUID: String!) {
    createPrint(accreditationUUID: $accreditationUUID){
      id
    }
  }`

export const BULK_CREATE_PRINT = gql`
  mutation bulkCreatePrint($id: ID!, $accreditationIds: [ID!]!) {
    bulkCreatePrint(id: $id, accreditationIds: $accreditationIds)
  }`

export const PRINT_ALL = gql`
  mutation printAll($id: ID!) {
    printAll(id: $id)
  }`
